module.exports = __webpack_public_path__ + "trunking_bw.svg?efbbbc664dfe1eee69b12e748a59b465";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/trunking_bw.svg
// module id = 23
// module chunks = 0